import type { FillCommand } from "../history/historyTypes";
import type { Rect } from "../comic/comicTypes";
import type { FillTolerance, RgbaTuple } from "./fillTypes";
import { FILL_HISTORY_COMMAND_ESTIMATE_BYTES } from "./fillMemory";

let fillSequence = 0;

function copyRgba(value: RgbaTuple): RgbaTuple {
  const copy: [number, number, number, number] = [value[0], value[1], value[2], value[3]];
  return Object.freeze(copy);
}

export function createFillCommand(input: {
  layerId: string;
  x: number;
  y: number;
  target: RgbaTuple;
  replacementColour: string;
  replacementOpacity: number;
  tolerance: FillTolerance;
  clipRect: Readonly<Rect>;
  panelId?: string;
}): FillCommand {
  fillSequence += 1;
  return Object.freeze({
    kind: "fill" as const,
    id: `fill-${fillSequence}`,
    layerId: input.layerId,
    x: Math.floor(input.x),
    y: Math.floor(input.y),
    target: copyRgba(input.target),
    replacementColour: input.replacementColour,
    replacementOpacity: Math.min(1, Math.max(0.1, input.replacementOpacity)),
    tolerance: input.tolerance,
    clipRect: Object.freeze({ ...input.clipRect }),
    ...(input.panelId ? { panelId: input.panelId } : {}),
    estimatedBytes: FILL_HISTORY_COMMAND_ESTIMATE_BYTES,
  });
}
